/**
 * 라우팅 파일 기본
 *
 * @export
 * @class Base
 */
export default class dtoBase {}
